<div class="auth-cover"></div>
<div class="container auth-login">
    <div id="login-wrapper">
        <div class="logos-wrapper">
            <img src="/assets/images/hds.png" width="202" height="101" alt="HDS Furniture">
            <img class="ashley-logo" src="/assets/images/ashley.png" width="128" height="56" alt="Ashley Furniture">
        </div>
        <form (ngSubmit)="onSubmit()">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'AUTH.EMAIL_LABEL' | translate }}</mat-label>
                <input matInput type="email" [formControl]="emailFormControl" name="email">
                <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                    {{ 'AUTH.EMAIL_INVALID' | translate }}
                </mat-error>
                <mat-error *ngIf="emailFormControl.hasError('required')">
                    {{ 'AUTH.EMAIL_REQUIRED' | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ 'AUTH.PASSWORD_LABEL' | translate }}</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" [formControl]="passwordFormControl" name="password" autocomplete="current-password">
                <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()" [attr.aria-label]="'AUTH.SHOW_PASSWORD' | translate">
                    <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <mat-error *ngIf="passwordFormControl.hasError('required')">
                    {{ 'AUTH.PASSWORD_REQUIRED' | translate }}
                </mat-error>
            </mat-form-field>

            <div class="login-error-message mt-3" *ngIf="errorMessage" aria-live="polite" role="alert">
                {{ errorMessage }}
            </div>
            <div class="text-right" *ngIf="loggingIn">
                {{ 'AUTH.VALIDATING' | translate }} <mat-progress-spinner mode="indeterminate" diameter="18" aria-label="Cargando"></mat-progress-spinner>
            </div>
            <div class="text-right" *ngIf="!loggingIn">
                <button mat-flat-button color="primary" [disabled]="emailFormControl.invalid || passwordFormControl.invalid">{{ 'AUTH.LOGIN' | translate }}</button>
            </div>
        </form>
        <div class="guest-section">
            <span class="guest-separator">{{ 'AUTH.OR' | translate }}</span>
            <button mat-stroked-button class="guest-btn" type="button" routerLink="/public">
                <mat-icon>qr_code_scanner</mat-icon>
                {{ 'AUTH.BROWSE_GUEST' | translate }}
            </button>
        </div>
    </div>
</div>
